import React from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreatorV2 from "../../common/FormCreatorV2";

import {
  formCreatorConvertToValues,
  useForm,
  getField,
} from "../../common/FormCreator/helpers";
import history from "../../history";
import { submitGLAAForms } from "../../redux/actions/glaaActions";

const StrongerTogetherDisclaimerForm = ({ appData, submitGLAAFormsFunc }) => {
  const { firstName = "", lastName = "" } = appData;

  const initialData = {
    StrongerTogetherDisclaimer8: `${firstName} ${lastName}`,
  };

  const getVal = getField(initialData);

  const initialState = {
    StrongerTogetherDisclaimer1: {
      title: "",
      type: "heading",
      textDescription: [
        "The Gangmasters and Labour Abuse Authority (GLAA) regulates those who supply labour or use workers to provide services in agriculture, forestry, horticulture, shellfish gathering and food processing and packaging.",
      ],
    },
    StrongerTogetherDisclaimer2: {
      title:
        "Have you paid anyone or will you have to pay anyone to obtain work?",
      value: getVal("StrongerTogetherDisclaimer2"),
      type: "checkbox",
      mandatory: true,
    },
    StrongerTogetherDisclaimer3: {
      title: "Comments",
      value: getVal("StrongerTogetherDisclaimer3"),
      type: "text",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "StrongerTogetherDisclaimer2",
        },
      ],
    },
    StrongerTogetherDisclaimer4: {
      title: "Have you paid anyone to get to the UK?",
      value: getVal("StrongerTogetherDisclaimer4"),
      type: "checkbox",
      mandatory: true,
    },
    StrongerTogetherDisclaimer5: {
      title: "Comments",
      value: getVal("StrongerTogetherDisclaimer5"),
      type: "text",
      mandatory: true,
      dependOn: [
        {
          fieldKey: "StrongerTogetherDisclaimer4",
        },
      ],
    },
    StrongerTogetherDisclaimer6: {
      title: "How did you find out about working for HRGO?",
      value: getVal("StrongerTogetherDisclaimer6"),
      type: "textarea",
      mandatory: true,
    },
    StrongerTogetherDisclaimer7: {
      title: "What is the name of your landlord?",
      value: getVal("StrongerTogetherDisclaimer7"),
      type: "text",
      mandatory: true,
    },
    StrongerTogetherDisclaimer8: {
      title: "Name (optional)",
      value: getVal("StrongerTogetherDisclaimer8"),
      type: "text",
      mandatory: false,
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    submitGLAAFormsFunc({
      ...fieldValuesPayload,
    });

    history.push("/profile");
  };

  return (
    <FormCreatorV2
      formTitle={"Stronger Together Disclaimer"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile")}
    />
  );
};

StrongerTogetherDisclaimerForm.propTypes = {
  appData: any,
  submitGLAAFormsFunc: func.isRequired,
};

const mapDispatchToProps = {
  submitGLAAFormsFunc: submitGLAAForms,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(StrongerTogetherDisclaimerForm);
